import { render } from "./choose.vue?vue&type=template&id=7df278aa&scoped=true"
import script from "./choose.vue?vue&type=script&lang=js"
export * from "./choose.vue?vue&type=script&lang=js"

import "./choose.vue?vue&type=style&index=0&id=7df278aa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df278aa"]])

export default __exports__